import React from "react";
import {connect} from "react-redux";
import MyTheme from "../../Theme/Theme";
import BoutonText from "./BoutonText";
import {StyleSheet, TouchableOpacity, View} from "react-native";


class BoutonTextPictoRight extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            isDark: false,
            theme : MyTheme.light
        }
    }

    render() {
        const styles = StyleSheet.create({
            ...this.props.style,
            container: {
                justifyContent:"center",
                alignItems:"center",
                marginVertical:10
            },
            containerParent  : {
                borderRadius : 10,
                borderWidth : 1,
                paddingVertical : 10,
                borderColor : this.props.theme.colors.tertiary.black10.value,
                justifyContent:"center",
                width:"100%"
            },
            textParent : {
                fontSize: 14,
                color:"red"
            }
        });
        return (<View style={[styles.container,styles.containerParent,styles.containerWidth]}><BoutonText isRed={this.props.isRed} style={styles} onPress={this.props.onPress} right={true} bold={this.props.bold} picto={this.props.picto} title={this.props.title} /></View>);
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(BoutonTextPictoRight);
